import styled from '@emotion/styled'

export const MeterPieChartContainer = styled.div<{
    height: string
}>(({ height }) => ({
    display: 'flex',
    position: 'relative',
    height: height,
    aspectRatio: '2 / 1',
}))

export const MeterPieChartMeterWrapper = styled.div<{
    /** In radians */
    rotation: number
}>(({ rotation }) => ({
    position: 'absolute',
    width: '100%',
    aspectRatio: '1',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    rotate: `${rotation}rad`,
    transformOrigin: '50% 50%',

    overflow: 'visible',

    transition: 'rotate 2000ms',
}))
